export default __webpack_public_path__ + "static/logo-white-a159d54f2a2cfae7cde4723a3c74d563.png";